"use client";

import React from "react";
import { BusinessContactForm } from "../components/contact_components/BusinessContactForm";
import { UserContactForm } from "../components/contact_components/UserContactForm";
import MainLayout from "../components/MainLayout";
import { successToast,errorToast } from '../utils/toasters'

export default function ContactPage() {
  const [activeTab, setActiveTab] = React.useState("business");

  return (
    <MainLayout rs={false}>
      <div className="min-h-screen  ">
        <div className="container mx-auto px-2 py-12">
          {/* Header with decorative elements */}
          <div className="relative mb-12 text-center">
            <div className="absolute inset-0 flex items-center justify-center opacity-10">
              <div className="h-64 w-64 rounded-full bg-purple-300 blur-3xl"></div>
              <div className="h-64 w-64 -ml-20 rounded-full bg-pink-300 blur-3xl"></div>
            </div>

            <div className="relative">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 md:text-5xl font-fraunces">
                Contact Us
              </h1>
              <div className="mt-4 flex justify-center">
                <div className="h-1 w-20 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full"></div>
              </div>
              <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
                Have questions or want to connect? We're here to help you with
                any inquiries or business opportunities.
              </p>
            </div>
          </div>

          {/* Main content */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              {/* Tabs */}
              <div className="bg-gray-50 px-6 py-4 border-b border-gray-100">
                <div className="grid w-full grid-cols-2 p-1 bg-gray-100 rounded-lg">
                  <button
                    onClick={() => setActiveTab("business")}
                    className={`text-sm md:text-base py-3 rounded-md transition-all ${
                      activeTab === "business"
                        ? "bg-white text-[#7B189F] shadow-sm"
                        : "bg-transparent text-gray-600 hover:text-gray-900"
                    }`}
                  >
                    For Businesses
                  </button>
                  <button
                    onClick={() => setActiveTab("users")}
                    className={`text-sm md:text-base py-3 rounded-md transition-all ${
                      activeTab === "users"
                        ? "bg-white text-[#7B189F] shadow-sm"
                        : "bg-transparent text-gray-600 hover:text-gray-900"
                    }`}
                  >
                    For Users
                  </button>
                </div>
              </div>

              <div className="p-8">
                {activeTab === "business" && (
                  <div className="space-y-6">
                    <div className="space-y-2">
                      <h2 className="text-2xl font-semibold text-gray-900 font-fraunces">
                        Business Inquiries
                      </h2>
                      <p className="text-gray-600">
                        Looking to promote your business or collaborate with us?
                        Fill out the form below and our team will get back to
                        you shortly.
                      </p>
                    </div>
                    <BusinessContactForm />
                  </div>
                )}

                {activeTab === "users" && (
                  <div className="space-y-6">
                    <div className="space-y-2">
                      <h2 className="text-2xl font-semibold text-gray-900 font-fraunces">
                        User Support
                      </h2>
                      <p className="text-gray-600">
                        Need help with your account or have questions about our
                        services? Let us know and we'll assist you as soon as
                        possible.
                      </p>
                    </div>
                    <UserContactForm />
                  </div>
                )}
              </div>
            </div>

            {/* <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 transform transition-transform hover:scale-105">
                <div className="mx-auto w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-[#7B189F]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Email Us
                </h3>
                <p className="text-gray-600 mb-2">For general inquiries:</p>
                <a
                  href="mailto:contact@example.com"
                  className="text-[#7B189F] hover:underline font-medium"
                >
                  contact@example.com
                </a>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 transform transition-transform hover:scale-105">
                <div className="mx-auto w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-[#7B189F]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Call Us
                </h3>
                <p className="text-gray-600 mb-2">Mon-Fri, 9am-6pm PST</p>
                <a
                  href="tel:+11234567890"
                  className="text-[#7B189F] hover:underline font-medium"
                >
                  +1 (123) 456-7890
                </a>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 transform transition-transform hover:scale-105">
                <div className="mx-auto w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-[#7B189F]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Visit Us
                </h3>
                <p className="text-gray-600 mb-2">123 Community Drive</p>
                <p className="text-[#7B189F] font-medium">
                  San Francisco, CA 94107
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
